import GuaranteeCreate from './GuaranteeCreate';

const guarantee = {
  create: GuaranteeCreate,
};

export default guarantee;
